<template>
    <div>
        <div>{{ requests.length }} demandes de paiement ont été créé pour ce module</div>

        <v-table>

            <thead>
                <tr>
                    <th class="text-left">Statut</th>
                    <th class="text-left">Montant</th>
                    <th class="text-left">Motif</th>
                    <th class="text-left">Email</th>
                    <th class="text-left">Date</th>
                    <th class="text-left">Actions</th>

                </tr>
            </thead>
            <tbody>
                <tr v-for="request in requests" :key="request.id">
                    <td>
                        <v-chip v-if="request.status == 'paid'" color="dark-green" variant="elevated"><v-icon
                                class="mr-1" icon="mdi-check"></v-icon> Payée</v-chip>
                        <v-chip v-else-if="request.status == 'pending'" color="primary-dark" variant="elevated"><v-icon
                                class="mr-1" icon="mdi-clock"></v-icon> En attente</v-chip>
                    </td>
                    <td>{{ request.total }}€</td>
                    <td>{{ request.motif }}</td>
                    <td>{{ request.email }}</td>
                    <td>{{ get_readable_date(request.timestamp) }}</td>
                    <td>
                        <router-link
                            :to="{ name: 'EditInscriptionAdmin', params: { id_inscription: request.id_inscription } }">
                            <v-btn size="small" variant="text" color="primary-dark"><v-icon
                                    class="mr-1">mdi-pencil</v-icon> Voir la fiche
                            </v-btn>
                        </router-link>
                    </td>



                </tr>
            </tbody>

        </v-table>

    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

import AdminService from "@/services/admin.service.js";
export default {
    data() {
        return {
            requests: [],
        };
    },
    computed: {
        ...mapStores(useMainStore),
    },

    methods: {
        get_readable_date(date) {
            return this.$moment(date).format("DD/MM/YYYY à HH:mm");
        },
    },
    async created() {
        this.requests = await AdminService.getModulePaymentsRequests(this.mainStore.module.id);
    },
};
</script>

<style lang="scss" scoped></style>